import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
} from '../../helpers/EventEmitter'
import ConnectMapService from '../core/service'

export const createConnectionMapLogs = createAsyncThunk(
  'connectMap/createConnectionMapLogs',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ConnectMapService.createConnectionMapLogs(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const updateConnectionMapLogs = createAsyncThunk(
  'connectMap/updateConnectionMapLogs',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ConnectMapService.updateConnectionMapLogs(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const upgradeConnectMap = createAsyncThunk(
  'connectMap/upgradeConnectMap',
  async (data, { rejectWithValue }) => {
    try {
      const res = await ConnectMapService.upgradeConnectMap(data)
      if (res.success) {
        EventEmitter.dispatch(
          SHOW_POPUP_CONFIRMATION,
          'domesticSearchPreview.CONTACT_US_CONFIRM',
        )
      }
      return rejectWithValue('Error')
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
